<app-unauthorized-header-layout header="Two-Factor Authentication"
    subHeader="Authenticator App" subHeader2="Enter the 6-digit code from your authenticator app."></app-unauthorized-header-layout>
@if (errorMessage) {
<div class="flex p-error justify-content-center mt-4 mb-2 text-xl">{{errorMessage}}</div>
}
<div class="flex justify-content-center flex-wrap w-full mt-3">
    <div class="surface-card w-saraplus-form border-round w-full sm:w-7 md:w-5 lg:4">
        <sp-form-wrapper [formGroup]="codeForm" (submit)="onValidate()">
            <div class="flex flex-column align-items-center">
                <div>
                    <div class="mb-3">
                        <p-inputOtp [autofocus]="true" formControlName="code" [tabindex]="1" [integerOnly]="true"
                            [length]="6" class="w-full mb-1 justify-content-between"></p-inputOtp>
                        <sp-control-error [parameters]="['Code']" [control]="codeForm.controls['code']"></sp-control-error>
                    </div>
                    <div class="flex justify-content-between mb-12rem">
                        <p-button icon="pi pi-chevron-left" label="Back" [link]="true"
                            styleClass="outline-none font-italic text-lg -ml-3" (click)="onBackClicked()"></p-button>
                        <button label="VALIDATE" pButton pRipple type="submit" [disabled]="!codeForm.valid" size="small">
                        </button>
                    </div>
                </div>
            </div>
        </sp-form-wrapper>
    </div>
</div>
